import Vue from 'vue'
import ShowClinicInfo from './index.vue'

Vue.component('ShowClinicInfo', ShowClinicInfo)



// WEBPACK FOOTER //
// ./src/components/showClinicInfo/load.js